import React from 'react';

import UserData from '@/types/User/UserData';

import { useGetUserPhasesQuery } from '../../api/use-get-user-phases.query';
import { UserPermissionsTable } from './user-permissions.table';

type Props = {
  user?: UserData | null;
};

export const UserPermissionsPhasesTable = ({ user }: Props) => {
  return <UserPermissionsTable query={useGetUserPhasesQuery} user={user} />;
};
